import { createContext } from 'react';
export const CurrentUserContext = createContext(null);
